// Порт из market: маска/нормализация РФ-телефона +7 XXX XXX XX XX.
const RU_PHONE_DIGITS_LENGTH = 11

export const extractRuPhoneDigits = (value: string): string => {
  let digits = value.replace(/\D/g, '')
  if (digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`
  }
  if (digits.startsWith('7')) {
    return digits.slice(0, RU_PHONE_DIGITS_LENGTH)
  }
  if (digits.length === 0) {
    return ''
  }
  return `7${digits}`.slice(0, RU_PHONE_DIGITS_LENGTH)
}

export const formatRuPhoneInput = (value: string): string => {
  const digits = extractRuPhoneDigits(value)
  if (digits.length === 0) {
    return '+7'
  }

  const national = digits.slice(1)
  const parts = ['+7']
  if (national.length > 0) {
    parts.push(national.slice(0, 3))
  }
  if (national.length > 3) {
    parts.push(national.slice(3, 6))
  }
  if (national.length > 6) {
    parts.push(national.slice(6, 8))
  }
  if (national.length > 8) {
    parts.push(national.slice(8, 10))
  }
  return parts.join(' ')
}

export const normalizeRuPhoneForApi = (value: string): string => {
  const digits = extractRuPhoneDigits(value)
  if (digits.length === 0) {
    return '+7'
  }
  return `+${digits}`
}

export const isRuPhoneComplete = (value: string): boolean =>
  extractRuPhoneDigits(value).length === RU_PHONE_DIGITS_LENGTH

export const handleRuPhoneInputChange = (rawValue: string, previousValue: string): string => {
  if (rawValue.length < previousValue.length && extractRuPhoneDigits(rawValue).length <= 1) {
    return '+7'
  }
  return formatRuPhoneInput(rawValue)
}
